import { gql } from '../../../../../hooks'

export const DELETE_COMPONENTS = gql`
  mutation AdministrationDeleteComponentComponents($id: ID!) {
    aDelete(path: "component/components", id: $id) {
    }
  }
`

export const LIST_COMPONENTS = gql`
  query AdministrationListComponentComponents(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/components"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
